import FeedbackPage from '@app-studio-web/ui/pages/FeedbackPage'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

export default function FeedbackSmartFeaturesPage() {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    navigate('/onboarding/question-plant-care-goal')
  }

  return (
    <FeedbackPage
      emoji="📱"
      heading={t('pages.onboarding.feedbackSmartFeatures.heading')}
      text={t('pages.onboarding.feedbackSmartFeatures.text')}
      onSubmit={handleSubmit}
    />
  )
}
